import NextLink from "next/link";
import { useTranslation } from "react-i18next";
import { Box, Link } from "@mui/material";
import { LoginForm } from "./login-form";

import { EAPP_ROUTE } from "../../enums/route.enum";
import { componentWrapper, displayFlexCenter } from "./styles";

export const LoginComponent = () => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        sx={{
          ...displayFlexCenter,
          mb: 3,
          mt: "5.4rem",
        }}
      >
        {t("login_page__rebranding_msg")}
      </Box>
      <Box sx={componentWrapper}>
        <LoginForm />
      </Box>
      <Box
        sx={{
          ...displayFlexCenter,
          mb: 3,
          mt: "5.4rem",
        }}
      >
        <NextLink href={EAPP_ROUTE.SIGNUP} passHref>
          <Link
            color="primary"
            variant="body2"
            data-testid="forget-password-link"
          >
            {t("login_page__create_account")}
          </Link>
        </NextLink>
      </Box>
      <Box
        sx={{
          ...displayFlexCenter,
          mb: 3,
          mt: 3,
        }}
      >
        <NextLink href={EAPP_ROUTE.FORGOT_PASSWORD} passHref>
          <Link
            color="primary"
            variant="body2"
            data-testid="forget-password-link"
          >
            {t("login_page__forgot_password")}
          </Link>
        </NextLink>
      </Box>
    </>
  );
};
